import { forwardRef, type ComponentProps, type ComponentRef } from 'react';
import { Popover as MuiPopover } from '@mui/material';
import { mergeSlotClassName } from './internal/mergeSlotClassName';

export type RwPopoverProps = ComponentProps<typeof MuiPopover>;

/** Paper marker for the shrink-wrapped content popover. Callers assert this instead of the DS class. */
export const RW_CONTENT_POPOVER_SURFACE = 'content-popover';

type PaperSlot = NonNullable<NonNullable<RwPopoverProps['slotProps']>['paper']>;

function contentPopoverPaper(paper: PaperSlot | undefined): PaperSlot {
  const merged = mergeSlotClassName(paper, 'rw-popover');
  if (typeof merged === 'function') {
    return ((ownerState: unknown) => ({
      ...merged(ownerState),
      'data-surface': RW_CONTENT_POPOVER_SURFACE
    })) as PaperSlot;
  }
  return { ...merged, 'data-surface': RW_CONTENT_POPOVER_SURFACE } as PaperSlot;
}

// Content popover (.rw-popover) shrink-wraps its content (width: max-content).
// .rw-menu is the list panel and is width: 100% of the modal, which stretches a
// picker into a full-width bar. Overlay shadow is re-asserted by the theme MuiPopover override.
export const RwPopover = forwardRef<ComponentRef<typeof MuiPopover>, RwPopoverProps>(function RwPopover({ slotProps, ...props }, ref) {
  return (
    <MuiPopover
      ref={ref}
      slotProps={{
        ...slotProps,
        paper: contentPopoverPaper(slotProps?.paper)
      }}
      {...props}
    />
  );
});
